import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from 'components/Shared/ConfirmModal';
import { useToggleCart } from 'hooks/cart/useToggleCart';
import { CartStepEnum, useCartValues } from '../../providers/CartProvider';
import * as StyledShared from '../../styles';

type CartCloseProps = {
  className?: string;
};

export const CartClose: FC<CartCloseProps> = ({ className }) => {
  const { t } = useTranslation();
  const { handleToggleCart } = useToggleCart();
  const { cartStep } = useCartValues();
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);

  const handleCloseIconClick = () => {
    if (cartStep === CartStepEnum.Payment) {
      setConfirmModalOpen(true);
    } else {
      handleToggleCart(false);
    }
  };

  return (
    <>
      <StyledShared.CloseIcon
        className={className}
        onClick={handleCloseIconClick}
      />
      <ConfirmModal
        title={t('generic.confirmAction')}
        description={t('generic.confirmActionDescription')}
        visible={isConfirmModalOpen}
        onCancel={() => setConfirmModalOpen(false)}
        onSubmit={() => handleToggleCart(false)}
        cancelWithButton
        cancelText={t('generic.cancel')}
      />
    </>
  );
};
